import { observable, action, computed } from 'mobx';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { enUS as en, it } from 'date-fns/locale';

momentDurationFormatSetup(moment);

class CommonStore {
  @observable
  longDateFormat;
  @observable dealer;
  @observable loading = false;
  @observable loadingMessage;

  @action
  setLongDateFormat(longDateFormat) {
    /**
     * L:"MM/DD/YYYY"
     * LL:"MMMM D, YYYY"
     * LLL:"MMMM D, YYYY h:mm A"
     * LLLL:"dddd, MMMM D, YYYY h:mm A"
     * LT:"h:mm A"
     * LTS:"h:mm:ss A"
     */
    this.longDateFormat = longDateFormat;
  }

  @computed
  get dateFnsLocale() {
    return moment.locale() === 'en' ? en : it;
  }

  @computed
  get momentLocale() {
    return moment.locale();
  }

  @action setDealer(dealer) {
    this.dealer = dealer;
    if (!!dealer.name) {
      this.dealer.companyName = dealer.name;
    }
  }

  @action setProfile(profile) {
    this.profile = profile;
  }

  @action setLoading(loading) {
    this.loading = loading;
  }

  @action setLoadingMessage(loadingMessage) {
    this.loadingMessage = loadingMessage;
  }

  @computed
  get isFleetCustomer() {
    return this.dealer && this.dealer.masterApiUserUuid;
  }
}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js